import React, { useEffect, useRef } from "react";
import { useBoundStore } from "../../store/useBoundStore";
import Logo from "../../assets/svg/logo-icon-weft.inline.svg";
import WeftIcon from "../../assets/svg/weft-logo-text.svg";

import styled from "styled-components";

const Holder = styled.div`
  position: fixed;
  pointer-events: none;
  height: var(--windowHeight);
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 200;
  opacity: 1;
  transition: opacity 1s ease-out;
  transition-delay: 1.2s;

  transition-duration: 2s;
  background: black;
  overflow: hidden;

  h1 {
    color: #00ffce;
  }

  &.hide {
    opacity: 0;
    cursor: default;
    pointer-events: none;
  }

  img {
    width: 100%;
    height: 10rem;
    display: block;
  }
`;

const Inner = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
    padding: 2rem;
`;

const IconHolder = styled.div`
  height: 10rem;
  svg,
  img {
      display: block;
    width: 100%;
    height: 100%;
    display: flex;
  }

  transition: opacity 1s ease-out;
  transition-duration: 1.5s;

  &.hide {
    opacity: 0;
  }

  &.logo {
    svg {
      margin-top: 3.2rem;
      height: 6.8rem;
      align-self: flex-end;
    }
  }
`;

const OpeningScreen = () => {
  const setShowOverlay = useBoundStore((state) => state.setShowOverlay);
  const showOverlay = useBoundStore((state) => state.showOverlay);

  useEffect(() => {
    const hideLogo = () => {
      setShowOverlay(false);
    };
    const timeoutId = setTimeout(hideLogo, 1000);

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
    };
  }, [showOverlay, setShowOverlay]);

  return (
    <Holder className={!showOverlay && "hide"}>
      <Inner>
        <IconHolder className={!showOverlay ? "hide logo" : "logo"}>
          <Logo />
        </IconHolder>
        <IconHolder className={!showOverlay && "hide"}>
          <img src={WeftIcon} alt="weft text logo" />
        </IconHolder>
      </Inner>
    </Holder>
  );
};

export default OpeningScreen;

